// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202608191126/js/" + chunkId + "." + {"44":"bd191488","225":"1b62d39a","481":"08b431b9","486":"c603cefb","770":"316427b0"}[chunkId] + ".0.07149064103252822.chunk.js";
};